(function () {
  const header = document.querySelector('.brand-header--sticky');
  if (!header) return;

  const spacer = document.querySelector('[data-brand-header-spacer]');
  if (!spacer) return;

  const SCROLL_THRESHOLD = 50;
  let headerHeight = header.offsetHeight;
  let lastScrollTop = 0;

  function handleSticky() {
    const currentScrollTop = window.scrollY;

    if (currentScrollTop > SCROLL_THRESHOLD) {
      header.classList.add('is-sticky');
      spacer.classList.add('is-active');
      spacer.style.height = headerHeight + 'px';

      if (currentScrollTop > lastScrollTop) {
        header.classList.add('is-hidden');
      } else {
        header.classList.remove('is-hidden');
      }
    } else {
      header.classList.remove('is-sticky');
      header.classList.remove('is-hidden');
      spacer.classList.remove('is-active');
    }

    lastScrollTop = currentScrollTop;
  }

  window.addEventListener('scroll', handleSticky, { passive: true });

  window.addEventListener('resize', function () {
    headerHeight = header.offsetHeight;
    if (spacer.classList.contains('is-active')) {
      spacer.style.height = headerHeight + 'px';
    }
  });

  window.addEventListener('load', function () {
    headerHeight = header.offsetHeight;
    handleSticky();
  });

  handleSticky();
})();

(function () {
  const drawer = document.querySelector('[data-brand-drawer]');
  if (!drawer) return;

  if (drawer.parentElement !== document.body) {
    document.body.appendChild(drawer);
  }

  const openButtons = document.querySelectorAll('[data-drawer-open]');
  const closeElements = drawer.querySelectorAll('[data-drawer-close]');
  const panel = drawer.querySelector('.brand-drawer__panel');
  const searchInput = drawer.querySelector('.brand-drawer__search-input');
  const searchClear = drawer.querySelector('[data-search-clear]');
  const searchForm = drawer.querySelector('.brand-drawer__search');
  const resultsEl = drawer.querySelector('[data-search-results]');
  const navEl = drawer.querySelector('[data-drawer-nav]');

  let lastFocused = null;

  function getFocusable(root) {
    return Array.from(
      root.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function open() {
    if (drawer.classList.contains('is-open')) return;
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    document.body.classList.add('brand-drawer-open');
    openButtons.forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    window.requestAnimationFrame(function () {
      const closeBtn = drawer.querySelector('[data-drawer-close]');
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    if (!drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    drawer.setAttribute('inert', '');
    document.body.classList.remove('brand-drawer-open');
    openButtons.forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  openButtons.forEach(function (btn) {
    btn.addEventListener('click', open);
  });

  closeElements.forEach(function (el) {
    el.addEventListener('click', close);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (drawer.classList.contains('is-open')) {
      event.preventDefault();
      close();
    }
  });

  drawer.addEventListener('keydown', function (event) {
    if (event.key !== 'Tab') return;
    if (!drawer.classList.contains('is-open')) return;
    const focusable = getFocusable(panel);
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  drawer.addEventListener('click', function (event) {
    if (event.target === drawer) close();
  });

  if (!searchInput || !resultsEl || !navEl) return;

  const SEARCH_MIN = 2;
  const SEARCH_DEBOUNCE = 220;
  let searchTimer = null;
  let searchAbort = null;

  function escapeHTML(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatPrice(rawPrice) {
    if (rawPrice == null || rawPrice === '') return '';
    const str = String(rawPrice).trim();
    if (/[€$£¥₹]/.test(str)) return str;
    const value = parseFloat(str.replace(/,/g, '.'));
    if (Number.isNaN(value)) return str;
    try {
      const currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency,
      }).format(value);
    } catch (e) {
      return value.toFixed(2);
    }
  }

  function showResults() {
    resultsEl.setAttribute('data-visible', 'true');
    navEl.setAttribute('data-hidden', 'true');
  }

  function hideResults() {
    resultsEl.removeAttribute('data-visible');
    navEl.removeAttribute('data-hidden');
    resultsEl.innerHTML = '';
  }

  function renderEmpty(q) {
    resultsEl.innerHTML =
      '<div class="brand-search-empty">Aucun résultat pour « ' + escapeHTML(q) + ' »</div>';
  }

  function renderLoading() {
    resultsEl.innerHTML = '<div class="brand-search-loading">Recherche…</div>';
  }

  function renderResults(results, q) {
    const products = (results && results.products) || [];
    const pages = (results && results.pages) || [];
    const articles = (results && results.articles) || [];
    const links = pages.concat(articles);

    if (products.length === 0 && links.length === 0) {
      renderEmpty(q);
      return;
    }

    const html = [];

    if (products.length) {
      html.push('<div class="brand-search-group">');
      html.push('<div class="brand-search-group__title">Produits</div>');
      html.push('<div class="brand-search-products">');
      products.forEach(function (p) {
        const img = p.featured_image
          ? '<img src="' + p.featured_image.url + '" alt="" loading="lazy">'
          : '';
        const price = formatPrice(p.price);
        html.push(
          '<a class="brand-search-product" href="' +
            p.url +
            '">' +
            '<div class="brand-search-product__media">' +
            img +
            '</div>' +
            '<div class="brand-search-product__text">' +
            '<span class="brand-search-product__title">' +
            escapeHTML(p.title) +
            '</span>' +
            (price ? '<span class="brand-search-product__price">' + price + '</span>' : '') +
            '</div>' +
            '</a>'
        );
      });
      html.push('</div></div>');
    }

    if (links.length) {
      html.push('<div class="brand-search-group">');
      html.push('<div class="brand-search-group__title">Pages & articles</div>');
      html.push('<div class="brand-search-links">');
      links.forEach(function (l) {
        html.push(
          '<a class="brand-search-link" href="' + l.url + '">' + escapeHTML(l.title) + '</a>'
        );
      });
      html.push('</div></div>');
    }

    html.push(
      '<a class="brand-search-view-all" href="/search?q=' +
        encodeURIComponent(q) +
        '&type=product">Voir tous les résultats</a>'
    );

    resultsEl.innerHTML = html.join('');
  }

  async function fetchSearch(q) {
    if (searchAbort) searchAbort.abort();
    searchAbort = new AbortController();
    try {
      const url =
        '/search/suggest.json?q=' +
        encodeURIComponent(q) +
        '&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last';
      const res = await fetch(url, {
        signal: searchAbort.signal,
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('HTTP ' + res.status);
      const data = await res.json();
      renderResults((data && data.resources && data.resources.results) || {}, q);
    } catch (e) {
      if (e.name === 'AbortError') return;
      resultsEl.innerHTML = '<div class="brand-search-empty">Recherche indisponible.</div>';
    }
  }

  function onInput() {
    const q = searchInput.value.trim();
    if (q.length < SEARCH_MIN) {
      clearTimeout(searchTimer);
      if (searchAbort) searchAbort.abort();
      hideResults();
      return;
    }
    showResults();
    renderLoading();
    clearTimeout(searchTimer);
    searchTimer = setTimeout(function () {
      fetchSearch(q);
    }, SEARCH_DEBOUNCE);
  }

  searchInput.addEventListener('input', onInput);
  searchInput.addEventListener('focus', function () {
    if (searchInput.value.trim().length >= SEARCH_MIN) {
      showResults();
      onInput();
    }
  });

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      hideResults();
      searchInput.focus();
    });
  }

  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      const q = searchInput.value.trim();
      if (!q) {
        e.preventDefault();
      }
    });
  }
})();

(function () {
  const items = document.querySelectorAll('[data-brand-nav-item]');
  if (items.length === 0) return;

  const CLOSE_DELAY = 120;
  let currentOpen = null;
  let closeTimer = null;

  function openItem(item) {
    if (currentOpen === item) return;
    if (currentOpen) closeItem(currentOpen);
    item.classList.add('is-open');
    const trigger = item.querySelector('[data-brand-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    currentOpen = item;
  }

  function closeItem(item) {
    item.classList.remove('is-open');
    const trigger = item.querySelector('[data-brand-nav-trigger]');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (currentOpen === item) currentOpen = null;
  }

  function closeAll() {
    items.forEach(function (item) {
      closeItem(item);
    });
  }

  items.forEach(function (item) {
    const trigger = item.querySelector('[data-brand-nav-trigger]');

    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      openItem(item);
    });

    item.addEventListener('mouseleave', function () {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        closeItem(item);
      }, CLOSE_DELAY);
    });

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.classList.contains('is-open')) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
      trigger.addEventListener('focus', function () {
        clearTimeout(closeTimer);
      });
    }

    const catTabs = item.querySelectorAll('[data-brand-nav-cat-tab]');
    const catPanels = item.querySelectorAll('[data-brand-nav-cat-panel]');

    function activateCat(catId) {
      catTabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-brand-nav-cat-tab') === catId);
      });
      catPanels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-brand-nav-cat-panel') === catId);
      });
    }

    catTabs.forEach(function (tab) {
      const cid = tab.getAttribute('data-brand-nav-cat-tab');
      tab.addEventListener('mouseenter', function () {
        activateCat(cid);
      });
      tab.addEventListener('focus', function () {
        activateCat(cid);
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && currentOpen) {
      const o = currentOpen;
      closeItem(o);
      const trigger = o.querySelector('[data-brand-nav-trigger]');
      if (trigger) trigger.focus();
    }
  });

  document.addEventListener('click', function (e) {
    if (currentOpen && !currentOpen.contains(e.target)) {
      closeAll();
    }
  });

})();
